<template>
  <div class="e2e-report-container">
    <div class="e2e-report-main">
      <div class="container">
        <div class="sc">
          <div class="sc-header">
            <div class="sc-title">
              E2E损益表（管理口径）
              <span class="tag tag-red">预算vs实际vs同期</span>
              <span class="tag tag-purple">全年展望</span>
            </div>
            <div class="sc-right">
              <span class="diff-threshold">差异阈值: 收入±2% | 毛利±5% | 费用±10%</span>
              <span class="sc-badge tag-red">收入差距-2,057万</span>
              <span class="sc-badge tag-red-bg">利润缺口-4,129万</span>
            </div>
          </div>

          <div class="report-table-wrap">
            <table class="report-table">
              <thead>
                <tr>
                  <th>科目（万元）</th>
                  <th class="col-actual">本月实际</th>
                  <th class="col-budget">月度预算</th>
                  <th class="col-variance">差异</th>
                  <th class="col-variance">差异%</th>
                  <th class="col-prior">上月实际</th>
                  <th class="col-ytd-a">本年累计</th>
                  <th class="col-ytd-b">累计预算</th>
                  <th class="col-ytd-v">累计差异</th>
                  <th class="col-fy-fc">全年预测</th>
                </tr>
              </thead>
              <tbody>
                <tr class="row-section"><td colspan="10">&#9654; 收入</td></tr>
                <tr class="highlight">
                  <td><span class="dot-red"></span>主营业务收入</td>
                  <td>46,143</td><td>48,200</td>
                  <td class="var-neg">-2,057</td><td class="var-neg">-4.3%</td>
                  <td>49,800</td>
                  <td>228,500</td><td>235,000</td>
                  <td class="var-neg">-6,500</td>
                  <td class="col-fy-fc">560,000</td>
                </tr>
                <tr>
                  <td style="padding-left:24px">&emsp;其中：内单收入</td>
                  <td>32,300</td><td>34,200</td>
                  <td class="var-neg">-1,900</td><td class="var-neg">-5.6%</td>
                  <td>35,600</td>
                  <td>162,000</td><td>168,500</td><td class="var-neg">-6,500</td>
                  <td class="col-muted">398,000</td>
                </tr>
                <tr>
                  <td style="padding-left:24px">&emsp;其中：外单收入</td>
                  <td>13,843</td><td>14,000</td>
                  <td class="var-neg">-157</td><td class="var-neg">-1.1%</td>
                  <td>14,200</td>
                  <td>66,500</td><td>66,500</td><td>0</td>
                  <td class="col-muted">162,000</td>
                </tr>

                <tr class="row-section"><td colspan="10">&#9654; 成本</td></tr>
                <tr>
                  <td><span class="dot-red"></span>主营业务成本</td>
                  <td>35,012</td><td>33,500</td>
                  <td class="var-neg">+1,512</td><td class="var-neg">+4.5%</td>
                  <td>37,200</td>
                  <td>173,400</td><td>163,500</td>
                  <td class="var-neg">+9,900</td>
                  <td class="col-fy-fc">392,000</td>
                </tr>
                <tr>
                  <td style="padding-left:24px">&emsp;其中：直接材料</td>
                  <td>21,007</td><td>19,765</td>
                  <td class="var-neg">+1,242</td><td class="var-neg">+6.3%</td>
                  <td>22,320</td>
                  <td>104,040</td><td>96,465</td><td class="var-neg">+7,575</td>
                  <td class="col-muted">231,280</td>
                </tr>
                <tr>
                  <td style="padding-left:24px">&emsp;其中：制造人工</td>
                  <td>6,302</td><td>6,365</td>
                  <td class="var-pos">-63</td><td class="var-pos">-1.0%</td>
                  <td>6,696</td>
                  <td>31,212</td><td>31,065</td><td class="var-neg">+147</td>
                  <td class="col-muted">74,480</td>
                </tr>
                <tr>
                  <td style="padding-left:24px">&emsp;其中：制造费用</td>
                  <td>7,703</td><td>7,370</td>
                  <td class="var-neg">+333</td><td class="var-neg">+4.5%</td>
                  <td>8,184</td>
                  <td>38,148</td><td>35,970</td><td class="var-neg">+2,178</td>
                  <td class="col-muted">86,240</td>
                </tr>

                <tr class="row-subtotal">
                  <td>毛利</td>
                  <td>11,131</td><td>14,700</td>
                  <td class="var-neg">-3,569</td><td class="var-neg">-24.3%</td>
                  <td>12,600</td>
                  <td>55,100</td><td>71,500</td>
                  <td class="var-neg">-16,400</td>
                  <td class="col-fy-fc-bold">168,000</td>
                </tr>
                <tr class="row-subtotal">
                  <td>毛利率</td>
                  <td class="var-neg">24.1%</td><td>30.5%</td>
                  <td class="var-neg">-6.4pp</td><td>—</td>
                  <td>25.3%</td>
                  <td class="var-neg">24.1%</td><td>30.4%</td><td class="var-neg">-6.3pp</td>
                  <td class="col-fy-fc-bold">30.0%</td>
                </tr>

                <tr class="row-section"><td colspan="10">&#9654; 费用</td></tr>
                <tr>
                  <td>销售费用</td>
                  <td>8,200</td><td>7,800</td>
                  <td class="var-neg">+400</td><td class="var-neg">+5.1%</td>
                  <td>7,500</td>
                  <td>39,800</td><td>38,000</td>
                  <td class="var-neg">+1,800</td>
                  <td class="col-muted">96,000</td>
                </tr>
                <tr>
                  <td>管理费用</td>
                  <td>3,100</td><td>3,000</td>
                  <td class="var-neg">+100</td><td class="var-neg">+3.3%</td>
                  <td>2,900</td>
                  <td>15,200</td><td>14,800</td>
                  <td class="var-neg">+400</td>
                  <td class="col-muted">37,000</td>
                </tr>
                <tr>
                  <td>研发费用</td>
                  <td>2,560</td><td>2,500</td>
                  <td class="var-neg">+60</td><td class="var-neg">+2.4%</td>
                  <td>2,400</td>
                  <td>12,400</td><td>12,200</td>
                  <td class="var-neg">+200</td>
                  <td class="col-muted">30,000</td>
                </tr>
                <tr class="row-subtotal">
                  <td>费用合计</td>
                  <td>13,860</td><td>13,300</td>
                  <td class="var-neg">+560</td><td class="var-neg">+4.2%</td>
                  <td>12,800</td>
                  <td>67,400</td><td>65,000</td>
                  <td class="var-neg">+2,400</td>
                  <td class="col-muted">163,000</td>
                </tr>

                <tr class="row-section"><td colspan="10">&#9654; 利润</td></tr>
                <tr class="row-subtotal highlight">
                  <td>经营利润</td>
                  <td class="var-neg">-2,729</td><td class="var-pos">+1,400</td>
                  <td class="var-neg">-4,129</td><td>—</td>
                  <td>-200</td>
                  <td class="var-neg">-12,300</td><td class="var-pos">+6,500</td>
                  <td class="var-neg">-18,800</td>
                  <td class="col-fy-fc-bold">5,000</td>
                </tr>
                <tr>
                  <td>财务费用(净)</td>
                  <td>420</td><td>380</td>
                  <td class="var-neg">+40</td><td class="var-neg">+10.5%</td>
                  <td>350</td>
                  <td>2,050</td><td>1,900</td>
                  <td class="var-neg">+150</td>
                  <td class="col-muted">4,800</td>
                </tr>
                <tr class="row-subtotal">
                  <td>净利润</td>
                  <td class="var-neg">-3,149</td><td class="var-pos">+1,020</td>
                  <td class="var-neg">-4,169</td><td>—</td>
                  <td>-550</td>
                  <td class="var-neg">-14,350</td><td class="var-pos">+4,600</td>
                  <td class="var-neg">-18,950</td>
                  <td class="col-fy-fc-bold">200</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="variance-attribution">
            <div class="attr-card attr-main">
              <span class="attr-main-label">收入差异归因分解</span>
              <span class="main-diff">-2,057<span class="main-unit"> 万元</span></span>
              <span class="main-eq">=</span>
              <div class="attr-item">
                <div class="attr-val red">-1,900<span class="attr-unit">万</span></div>
                <div class="attr-label">量差</div>
              </div>
              <span class="main-eq">+</span>
              <div class="attr-item">
                <div class="attr-val amber">-157<span class="attr-unit">万</span></div>
                <div class="attr-label">价差</div>
              </div>
            </div>
            <div class="attr-card">
              <div class="attr-label">量差驱动因素</div>
              <div class="attr-val red">-1,900万</div>
              <div class="attr-sub">占收入差的 92.4%</div>
              <div class="attr-breakdown">3家重点客户推迟交货计划至下月是内单收入未达标主因</div>
            </div>
            <div class="attr-card">
              <div class="attr-label">价差驱动因素</div>
              <div class="attr-val amber">-157万</div>
              <div class="attr-sub">占收入差的 7.6%</div>
              <div class="attr-breakdown">外单收入13,843万，差预算157万（-1.1%），基本达标</div>
            </div>
            <div class="attr-card">
              <div class="attr-label">成本差异驱动</div>
              <div class="attr-val purple">+1,512万</div>
              <div class="attr-sub">毛利影响-1,512万</div>
              <div class="attr-breakdown">直接材料超预算+6.3%（铜箔涨价），制造费用超预算+4.5%</div>
            </div>
          </div>

          <div class="annot-footnote">
            <b>&#9432; 全年展望</b>：全年收入预测56.0亿，较年初预算略有下调。核心风险：<b style="color:var(--red)">直接材料成本上升</b>（铜箔涨价，对应毛利影响-1,512万/月）+ <b style="color:var(--amber)">收入达成滞后</b>（内单收入差预算1,900万）。毛利率当前24.1%，距目标30.5%差6.4pp——<b style="color:var(--red)">下半年需重点推进成本管控和收入追回</b>。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'E2EReport',
  data() {
    return {
      activeMonth: '5',
      months: [
        { value: '5', label: '5月' },
        { value: '4', label: '4月' },
        { value: '3', label: '3月' },
        { value: '2', label: '2月' },
        { value: '1', label: '1月' }
      ]
    }
  },
  methods: {
    switchMonth(m) {
      this.activeMonth = m
    }
  }
}
</script>

<style scoped>
:root {
  --bg: #f0f3f8;
  --surface: #fff;
  --surface2: #f7f9fc;
  --border: rgba(0,0,0,.06);
  --border2: rgba(0,0,0,.10);
  --text: #1a2332;
  --text2: #3d4f5f;
  --muted: #6b7f9a;
  --line: #dce3ed;
  --blue: #2d7ff9;
  --blue2: #4a5ff3;
  --green: #0aa66a;
  --red: #e54b3d;
  --amber: #d98213;
  --purple: #7f55d9;
  --shadow: 0 1px 3px rgba(0,0,0,.04), 0 4px 14px rgba(0,0,0,.06);
  --radius: 8px;
  --radius-sm: 6px;
}

.e2e-report-container {
  background: var(--bg);
  height: 100%;
  border-radius: 8px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;
}
.e2e-report-container::-webkit-scrollbar {
  width: 4px;
}
.e2e-report-container::-webkit-scrollbar-track {
  background: transparent;
}
.e2e-report-container::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}
.e2e-report-main {
  background: white;
  border-radius: 8px;
}

.container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.sc {
  background: var(--surface);
  border-radius: var(--radius);
  border: 1px solid var(--border);
  padding: 20px 24px;
  box-shadow: var(--shadow);
}

.sc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
  flex-wrap: wrap;
  gap: 12px;
}

.sc-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 8px;
}

.sc-right {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.diff-threshold {
  font-size: 10px;
  color: var(--muted);
}

.sc-badge {
  font-size: 9px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 600;
}

.tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 600;
}

.tag-red {
  background: rgba(229,75,61,.08);
  color: var(--red);
}

.tag-purple {
  background: rgba(127,85,217,.08);
  color: var(--purple);
}

.tag-red-bg {
  background: rgba(229,75,61,.1);
  color: var(--red);
}

.report-table-wrap {
  overflow-x: auto;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 900px;
}

.report-table thead th {
  padding: 8px 10px;
  text-align: right;
  font-size: 10px;
  color: var(--muted);
  font-weight: 500;
  border-bottom: 2px solid var(--line);
  white-space: nowrap;
  background: var(--surface2);
}

.report-table thead th:first-child {
  text-align: left;
}

.report-table thead th.col-actual {
  color: var(--blue);
}

.report-table thead th.col-budget {
  color: var(--muted);
}

.report-table thead th.col-variance {
  color: var(--red);
}

.report-table thead th.col-prior {
  color: var(--muted);
}

.report-table thead th.col-ytd-a {
  color: var(--blue);
}

.report-table thead th.col-ytd-b {
  color: var(--muted);
}

.report-table thead th.col-ytd-v {
  color: var(--red);
}

.report-table thead th.col-fy-fc {
  color: var(--purple);
  font-weight: 700;
}

.report-table tbody td {
  padding: 7px 10px;
  text-align: right;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
}

.report-table tbody td:first-child {
  text-align: left;
  font-weight: 600;
  color: var(--text);
}

.report-table .row-section td {
  background: var(--surface2);
  font-weight: 700;
  font-size: 11px;
  color: var(--text);
  border-bottom: 1px solid var(--line);
}

.report-table .row-section td:first-child {
  color: var(--blue2);
}

.report-table .row-subtotal td {
  background: linear-gradient(135deg, rgba(45,127,249,.04), rgba(0,175,240,.02));
  font-weight: 700;
  border-bottom: 2px solid var(--line);
}

.report-table .var-neg {
  color: var(--red);
  font-weight: 700;
}

.report-table .var-pos {
  color: var(--green);
  font-weight: 700;
}

.report-table .highlight {
  background: rgba(229,75,61,.04) !important;
}

.report-table .col-fy-fc {
  color: var(--purple);
  font-weight: 600;
}

.report-table .col-fy-fc-bold {
  color: var(--purple);
  font-weight: 700;
}

.report-table .col-muted {
  color: var(--muted);
}

.dot-red {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--red);
  margin-right: 4px;
}

.variance-attribution {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px dashed var(--line);
}

.attr-card {
  padding: 6px 8px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--surface2);
  text-align: center;
}

.attr-card.attr-main {
  grid-column: 1 / -1;
  background: linear-gradient(135deg, rgba(229,75,61,.03), #fff);
  border-color: rgba(229,75,61,.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px 16px;
}

.attr-main-label {
  font-size: 13px;
  font-weight: 700;
  color: var(--text);
}

.main-diff {
  font-size: 18px;
  font-weight: 800;
  color: var(--red);
}

.main-unit {
  font-size: 12px;
  font-weight: 500;
}

.main-eq {
  font-size: 12px;
  color: var(--muted);
}

.attr-item {
  text-align: center;
}

.attr-label {
  font-size: 9px;
  color: var(--muted);
  margin-bottom: 2px;
  text-transform: uppercase;
  letter-spacing: .4px;
}

.attr-val {
  font-size: 16px;
  font-weight: 800;
}

.attr-unit {
  font-size: 10px;
  font-weight: 500;
}

.attr-sub {
  font-size: 8px;
  color: var(--muted);
  margin-top: 1px;
}

.attr-val.red {
  color: var(--red);
}

.attr-val.amber {
  color: var(--amber);
}

.attr-val.purple {
  color: var(--purple);
}

.attr-breakdown {
  font-size: 8px;
  color: var(--muted);
  margin-top: 3px;
  padding-top: 3px;
  border-top: 1px dashed var(--border);
}

.annot-footnote {
  margin-top: 12px;
  padding: 10px 14px;
  background: var(--surface2);
  border-radius: var(--radius-sm);
  font-size: 9px;
  color: var(--muted);
  line-height: 1.6;
}

.annot-footnote b {
  color: var(--text2);
}
</style>
